
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.919","height":"9.82","viewBox":"0 0 12.919 9.82"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.244.741a.6.6 0 00-.843 0l-7.14 7.14-2.744-2.744a.6.6 0 10-.843.843L3.84 9.145a.6.6 0 00.843 0l7.561-7.561a.6.6 0 000-.843z","fill":"#fff","stroke":"#fff"}})])
          )
        }
      }
    